var map = {
	"./fade.js": "./js/barba/transitions/fade.js",
	"./slide-left.js": "./js/barba/transitions/slide-left.js",
	"./slide-right.js": "./js/barba/transitions/slide-right.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./js/barba/transitions sync \\.js$";